import React from "react";
import { Route, IndexRoute, IndexRedirect, Link, Redirect } from "react-router";
import { requireAuthentication } from "./components/requireAuthentication.js";

import App from "./containers/App.js";
import Builder from "./containers/builder/index.js";
import Email from "./containers/builder/email.js";
import Picker from "./containers/builder/Picker.js";
import Popup from "./containers/builder/Popup.js";

import PickerStep1 from "./containers/picker/step1.js";
import PickerStep2 from "./containers/picker/step2.js";
import PickerStep3 from "./containers/picker/step3.js";

import Dashboard from "./containers/dashboard/dashboard.js";
import Protected from "./containers/Protected.js";
import FullPage from "./containers/FullPage.js";

import Login from "./containers/login/index.js";
import Forgot from "./containers/login/forgot.js";
import Reset from "./containers/login/reset.js";

import Logout from "./containers/login/Logout.js";
import NotFound from "./containers/NotFound.js";
import Invitation from "./containers/login/Invitation.js";
import Signup from "./containers/login/signup.js";

import Emails from "./containers/emails/emails.js";
import Abtests from "./containers/emails/abtests.js";
import Templates from "./containers/emails/templates.js";
import Popups from "./containers/popups/popups.js";
import Discounts from "./containers/discounts/discounts.js";
import DiscountNew from "./containers/discounts/DiscountNew.js";

import Chat from "./containers/chat/Chat.js";
import ChatOverview from "./containers/chat/ChatOverview.js";
import ChatConversation from "./containers/chat/ChatConversation.js";

import Settings from "./containers/settings/Settings.js";
import SettingsProfile from "./containers/settings/SettingsProfile.js";
import SettingsUsers from "./containers/settings/SettingsUsers.js";
import SettingsEmails from "./containers/settings/SettingsEmails.js";
import SettingsChat from "./containers/settings/SettingsChat.js";
import SettingsPush from "./containers/settings/SettingsPush.js";
import SettingsCompany from "./containers/settings/SettingsCompany.js";

import Billing from "./containers/settings/Billing.js";
import BillingOverview from "./containers/settings/BillingOverview.js";
import BillingInvoices from "./containers/settings/BillingInvoices.js";
import BillingSubscribe from "./containers/settings/BillingSubscribe.js";
import BillingPlan from "./containers/settings/BillingPlan.js";
import BillingCard from "./containers/settings/BillingCard.js";
import BillingCancel from "./containers/settings/BillingCancel.js";
import BillingDealer from "./containers/settings/BillingDealer.js";

import Apps from "./containers/apps/Apps.js";
import AppBrowse from "./containers/apps/AppBrowse.js";
import AppIndex from "./containers/apps/AppIndex.js";

import Analytics from "./containers/analytics/analytics.js";
import Setup from "./containers/setup/setup.js";

import Segments from "./containers/segments/segments.js";
import Events from "./containers/events/events.js";
import Orders from "./containers/orders/orders.js";

import Startup from "./containers/startup/startup.js";
import Push from "./containers/push/Push.js";
import PushNew from "./containers/push/PushNew.js";
import SettingsDiscount from "./containers/settings/SettingsDiscount";
import SettingsSync from "./containers/settings/SettingsSync";
import Recommendations from "./containers/recommendations/recommendations";
import RecommendationsTemplates from "./containers/recommendations/templates";
import NewRecommendation from "./containers/recommendations/new";
import Stats from "./containers/stats/stats";

import NewslettersIndex from "./containers/newsletters/index";

export default (
    <Route path="/" component={App}>
        <IndexRedirect to="login" />

        <Route
            path=":account_id/builder"
            component={requireAuthentication(Builder)}
        >
            <Route path=":type/picker" component={Picker}>
                <IndexRedirect to="1" />
                <Route path="1" component={PickerStep1} />
                <Route path="2" component={PickerStep2} />
                <Route path="3" component={PickerStep3} />
            </Route>
            <Route path="email/:email_id/:type" component={Email} />
            <Route path="email/:email_id" component={Email} />
            <Route path="popup/:popup_id" component={Popup} />
        </Route>

        <Route
            path=":account_id/setup"
            component={requireAuthentication(Setup)}
        />

        <Route path=":account_id/" component={requireAuthentication(FullPage)}>
            <IndexRedirect to="dashboard" />
            <Route path="dashboard" component={Dashboard} />
            <Route path="emails" component={Emails} />
            <Route path="emails/tests" component={Abtests} />
            <Route path="emails/templates" component={Templates} />

            <Route path="recommendations" component={Recommendations} />
            <Route path="recommendations/new" component={NewRecommendation} />
            <Route
                path="recommendations/templates"
                component={RecommendationsTemplates}
            />
            <Route
                path="recommendations/:recommendation_id"
                component={NewRecommendation}
            />

            <Route path="newsletters" component={NewslettersIndex} />

            <Route path="popups" component={Popups} />
            <Route path="discounts" component={Discounts} />
            <Route path="discounts/new" component={DiscountNew} />

            <Route path="discounts/:discount_id" component={DiscountNew} />

            <Route path="push" component={Push} />
            <Route path="push/new" component={PushNew} />
            <Route path="push/:discount_id" component={PushNew} />

            <Route path="stats/:type/:id" component={Stats} />

            <Route path="segments" component={Segments} />
            <Route path="segments/:id" component={Segments} />
            <Route path="events" component={Events} />

            <Route path="orders" component={Orders} />
            <Route path="welcome" component={Startup} />

            <Route path="chat" component={Chat}>
                <IndexRedirect to="overview" />
                <Route path="overview" component={ChatOverview} />
                <Route path=":user_id" component={ChatConversation} />
                <Route path=":user_id/:uid" component={ChatConversation} />
            </Route>

            <Route path="insights" component={Analytics} />

            <Route path="settings" component={Settings}>
                <IndexRedirect to="me" />
                <Route path="me" component={SettingsProfile} />
                <Route path="users" component={SettingsUsers} />
                <Route path="emails" component={SettingsEmails} />
                <Route path="chat" component={SettingsChat} />
                <Route path="push" component={SettingsPush} />
                <Route path="company" component={SettingsCompany} />
                <Route path="discount" component={SettingsDiscount} />
                <Route path="sync" component={SettingsSync} />

                <Route path="billing" component={Billing}>
                    <IndexRedirect to="overview" />
                    <Route path="overview" component={BillingOverview} />
                    <Route path="subscribe" component={BillingSubscribe} />
                    <Route path="invoices" component={BillingInvoices} />
                    <Route path="plan" component={BillingPlan} />
                    <Route path="card" component={BillingCard} />
                    <Route path="cancel" component={BillingCancel} />
                    <Route path="dealer" component={BillingDealer} />
                </Route>
            </Route>

            <Route path="apps" component={Apps}>
                <IndexRedirect to="browse" />
                <Route path="browse" component={AppBrowse} />
                <Route path=":app" component={AppIndex} />
            </Route>
        </Route>

        <Route path=":account_id/invitation" component={Invitation} />
        <Route path="signup" component={Signup} />
        <Route path="forgot" component={Forgot} />
        <Route path="reset/:token" component={Reset} />
        <Route path="login" component={requireAuthentication(Login)} />

        <Route path="*" component={NotFound} />
    </Route>
);



// WEBPACK FOOTER //
// ./routes.js